import React from "react";
import MultiSelectDropdown from "../../components/multiSelectDropdown/multiSelectDropdown";
import { useSelector, useDispatch } from "react-redux";

const BASE_VIEW_OPTIONS = [
  { id: "invoice_category", name: "Invoice Type" },
  { id: "purchase_category", name: "Payment Category" },
  { id: "transaction_category", name: "Transaction Type" }
];

export const revenueViewOptions = [
  { id: "revenue_category", name: "Revenue Category" },
  ...BASE_VIEW_OPTIONS
];

export const totalRevenueViewOptions = [
  { id: "revenue_category", name: "Revenue Type" },
  ...BASE_VIEW_OPTIONS
];

export const DEFAULT_REVENUE_VIEW = revenueViewOptions[0];
export const DEFAULT_TOTAL_REVENUE_VIEW = totalRevenueViewOptions[0];

const ViewFilter = ({ stateKey, updateRevenueView, options = revenueViewOptions }) => {
  const dispatch = useDispatch();

  const selectedView = useSelector((state) => state[stateKey].selectedRevenueView);

  return (
    <MultiSelectDropdown
      options={options}
      selectedFilters={selectedView}
      placeholder="Select View"
      numberDisplayed={0}
      multiple={false}
      keepOpen={false}
      includeFilter={false}
      onSelectChange={(data) => {
        if (data.id === selectedView.id) return;
        dispatch(updateRevenueView(data));
      }}
    />
  );
};

export default ViewFilter;
